export default __webpack_public_path__ + "static/media/sanofi.c1150759.png";